// const drawerWidth = 240;

export const styles = theme => {
  return ({
    weekly: {
      display: 'flex',
      flexDirection: 'col',
      // alignContent: ''
    },
    attendanceHeader: {
      height: '30px',
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '20px',
      width: '172px',
    },
    paper: {
      padding: '40px',
      margin: '100px',
    },
    paperHeaderRow: {
      height: '20px',
      margin: '20px',
      marginBottom: '40px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignContent: 'center',
    },
    columnHeaderCells: {
      margin: '100px',
    },
    attendanceContainer: {
      width: '900px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignContent: 'flex-start',
    },
    attendanceColumns: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    attendanceCell: {
      height: '50px',
      display: 'flex',
      alignItems: 'center',
    },
    selectContainer: {
      width: '172px',
    }
  });
};
